import { List, Map } from "lucide-react"

export function ViewToggle({ activeView, onViewChange }) {
  const views = [
    { key: "list", label: "List", icon: List },
    { key: "map", label: "Map", icon: Map },
  ]

  return (
    <div className="flex justify-center">
      <div className="inline-flex bg-white border border-zinc-200 rounded-sm overflow-hidden">
        {views.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => onViewChange(key)}
            className={`flex items-center gap-2 px-6 py-3 text-sm font-semibold uppercase tracking-wider transition-all ${
              activeView === key
                ? "bg-kf-gradient text-white"
                : "text-zinc-600 hover:text-kf-red"
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}
